import Vue from 'vue';
import select from 'element-ui';
import Pagination from '@/components/pagination';
import DatePicker from '@/components/datePicker';
const projectComponents = [
  Pagination,
  DatePicker,
];

const plugin = {
  install(Vue) {
    projectComponents.forEach((comp) => {
      Vue.component(comp.name, comp);
    });
  },
};


export default plugin;
export const install = plugin.install;